import { render } from "./UserTableConstellation.vue?vue&type=template&id=5aac2b82&scoped=true&ts=true"
import script from "./UserTableConstellation.vue?vue&type=script&lang=ts"
export * from "./UserTableConstellation.vue?vue&type=script&lang=ts"

import "./UserTableConstellation.vue?vue&type=style&index=0&id=5aac2b82&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aac2b82"]])

export default __exports__